export enum EnumReasonResetPassword {
    Create = 'Create',
    Modify = 'Modify',
    Loose = 'Loose',
}
